import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useHistory } from 'react-router-dom';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { FiShoppingCart } from 'react-icons/fi';
import TheLayout from '../../layout/TheLayout';
import FirstView from '../../asset/firstview.png';
import NavSidebar from '../Util/NavSidebar/NavSidebar';
import TestshopImg from '../../asset/Testshop/testshop.png';
import {
  addToCart,
} from '../../redux/actions/cart';

const keywords = ['TERRA', 'ウイルス対策', '除菌剤', '港区', '赤坂', 'TERRA FORESTA', 'TERRA COAT', '光触媒コーディング （編集済み）'];

const Testshop = () => {
  const accessToken = useSelector((state) => state.auth.accessToken, shallowEqual);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn, shallowEqual);
  const productList = useSelector((state) => state.product.productList, shallowEqual);
  const dispatch = useDispatch();
  const history = useHistory();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  let product = {};
  productList.forEach((item) => {
    if (item?.product_categories[0]?.category_name === 'お試し') {
      product = item;
    }
  });
  const clickAddToCard = () => {
    if (product === undefined) {
      return;
    }
    dispatch(addToCart(product, 1, accessToken, isLoggedIn, 'cart', history));
    history.push('/cart');
  };
  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>Test Shop｜株式会社TERRA</title>
      </Helmet>
      <div className="testshop">
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          TEST SHOP
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>TEST SHOP</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="content container">
          <div className="row">
            <div className="col-3 d-none d-lg-block p-0" style={{ background: 'white' }}>
              <NavSidebar />
            </div>
            <div className="col-12 col-lg-9">
              <div className="p-2 p-lg-4">
                <div className="row">
                  <div className="col-12 col-lg-6 mb-5">
                    <img src={TestshopImg} style={{ width: '100%' }} alt="TERRA FORESTAハンディスプレー" />
                  </div>
                  <div className="col-12 col-lg-6">
                    <span
                      className="px-3 mt-2"
                      style={{
                        background: 'rgb(44,81,115)',
                        color: 'white',
                        borderRadius: '1rem',
                      }}
                    >
                      100ml
                    </span>
                    <h3 className="mt-4">TERRA FORESTAハンディスプレー</h3>
                    <p
                      className="mt-4"
                      style={{
                        fontSize: '2.5rem',
                      }}
                    >
                      ￥2,200
                      <span
                        style={{
                          fontSize: '1.3rem',
                        }}
                      >
                        （税込）
                      </span>
                    </p>
                    <button
                      className=" btn rounded my-5"
                      style={{
                        background: 'rgb(44,81,115)',
                        color: 'white',
                        borderRadius: '1rem',
                        lineHeight: '3rem',
                        Height: '3rem',
                        textAlign: 'center',
                        maxWidth: '300px',
                        margin: 'auto',
                      }}
                      type="button"
                      onClick={clickAddToCard}
                    >
                      <FiShoppingCart style={{ fontSize: '1.3rem', marginRight: '15px' }} />
                      カートに追加
                    </button>
                    <p className="my-4">
                      高い除菌・抗菌・消臭作用をもつ植物の抽出エキスで作られ、アルコールや塩素は使用しておらず手肌に優しい除菌・消臭スプレーです。
                      サラッとした感触なので塗った感触が残りません。
                      <br />
                      また、小さいサイズなので鞄の中で幅をとらずに持ち運びができまでので、お試しで使いたい方にお勧め商品です。
                    </p>
                    <table className="table table-bordered my-5" style={{ color: 'rgb(44,81,115)' }}>
                      <tbody>
                        <tr>
                          <th style={{ width: '30%' }}>商品名</th>
                          <td style={{ width: '70%' }}>TERRA FORESTA ハンディスプレー</td>
                        </tr>
                        <tr>
                          <th style={{ width: '30%' }}>販売価格</th>
                          <td style={{ width: '70%' }}>2,200円（税込）</td>
                        </tr>
                        <tr>
                          <th style={{ width: '30%' }}>お勧めのご利用場所</th>
                          <td style={{ width: '70%' }}>
                            持ち運び、玄関、机
                          </td>
                        </tr>
                        <tr>
                          <th style={{ width: '30%' }}>容量</th>
                          <td style={{ width: '70%' }}>
                            100ml
                          </td>
                        </tr>
                        <tr>
                          <th style={{ width: '30%' }}>成分</th>
                          <td style={{ width: '70%' }}>
                            植物抽出エキス（青森ヒバ、紀州ヒノキ、ユーカリ）、イオン水（銅・亜鉛）
                          </td>
                        </tr>
                        <tr>
                          <th style={{ width: '30%' }}>成分</th>
                          <td style={{ width: '70%' }}>
                            高さ　15cm
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </TheLayout>
  );
};
export default Testshop;
